/**
 * The letters that stand in for a face.
 *
 * Taken from whatever Microsoft gave us at sign-in — the display name if there
 * is one, the address if there is not, which is why the separators include the
 * ones an address is built from. Two letters where there are two words, one
 * where there is only one, and never nothing: a blank circle beside a message
 * reads as a picture that failed to load rather than as a person.
 */
export function initials(displayName: string, email: string): string {
  const source = displayName.trim() || email
  const parts = source.split(/[\s.@_-]+/).filter(Boolean)
  if (parts.length === 0) return '?'
  if (parts.length === 1) return parts[0].slice(0, 1).toUpperCase()
  return (parts[0][0] + parts[1][0]).toUpperCase()
}
